module.exports = __webpack_public_path__ + "static1/img/2fff5871d79b20b2667e7f7b627fb31.38f0604.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/2fff5871d79b20b2667e7f7b627fb31.png
// module id = Epug
// module chunks = 1